import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';

const state = {
    worker: '',
    worker_list: [],
    failed_jobs: '',
    pending_jobs: '',
    sync_jobs: '',
    meta:[]
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
